<template>
    <div class="inline-flex w-full justify-between">
        <BaseButton
            class="text-theme-icon"
            dusk="buttonTableOfContentsMobile"
            type="button"
            :tooltip="localizations[lang].tooltips.tableOfContents"
            icon="baseline-view_list-24px"
            width="24px"
            height="24px"
            @click="toggleTableOfContents"
        />
        <BaseButton
            v-if="showListeningAction"
            :class="{ active: listeningIsActive }"
            :disabled="isOffline"
            :tooltip="localizations[lang].tooltips.listen"
            icon-class="text-theme-icon"
            icon="baseline-headset-24px"
            width="24px"
            height="24px"
            @click="listeningPage"
        />
        <BaseButton
            dusk="toggleSettings"
            class="text-theme-icon"
            :tooltip="localizations[lang].tooltips.config"
            :class="{ active: ui.settings.opened }"
            icon="display-setting"
            width="24px"
            height="24px"
            @click="toggleSettings"
        />
        <BaseButton
            v-if="isPdf"
            v-show="ui.thumbnails.enabled"
            class="text-theme-icon"
            :tooltip="localizations[lang].tooltips.openThumbnails"
            icon="baseline-apps-24px"
            width="24px"
            height="24px"
            @click="toggleThumbnails"
        />
    </div>
</template>

<script>
import BaseButton from '../Components/buttons/BaseButton.vue';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    components: {
        BaseButton,
    },
    computed: {
        ...mapState(['ui', 'isOffline', 'localizations', 'lang']),
        ...mapGetters(['isPdf']),
        listeningIsActive() {
            return this.ui.listening.opened && this.ui.listening.texToListen === this.ui.listening.pageToListen;
        },
        showListeningAction() {
            return this.ui.listening.enabled && this.ui.listening.pageToListen;
        },
    },
    methods: {
        ...mapActions([
            'listeningPage',
            'toggleTableOfContents',
            'toggleThumbnails',
            'toggleNotebook',
            'toggleSettings',
        ]),
    },
};
</script>

<style scoped lang="scss"></style>
